import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import MediatorManager from "../../../core/application/MediatorManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import SkinKeyRegistry from "../../../core/ui/SkinKeyRegistry";
import PullContentManager from "../../../ngt/pull/PullContentManager";
import OpenMapCharacterMenuEvent from "../event/OpenMapCharacterMenuEvent";
import MapInteractionEvent from "../event/MapInteractionEvent";
import MapLocationAvailabilityEvent from "../event/MapLocationAvailabilityEvent";
import MapModel from "../model/MapModel";
import MapLocationMediator from "./MapLocationMediator";
import CloseMapCharacterMenuEvent from "../event/CloseMapCharacterMenuEvent";

export default class MapMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {MediatorManager} mediatorManager 
     * @param {MapModel} mapModel 
     * @param {PullContentManager} pullContentManager
     * @param {RevisableLanguagePack} languagePack
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, mediatorManager, mapModel, pullContentManager, languagePack) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._mediatorManager = mediatorManager;
        this._mapModel = mapModel;
        this._pullContentManager = pullContentManager;
        this._languagePack = languagePack;

        /** @type {Array<MapLocationMediator>} */
        this._mapLocationMediators = [];

        this._onMapClickBound = this._onMapClick.bind(this);
    }

    initialize() {
        super.initialize();

        this._initializeNodes();

        this._target.bg.addEventListener('click', this._onMapClickBound);

        this.registerEventListener(MapLocationAvailabilityEvent.LOCATION_AVAILABLE, this._handleLocationAvailable.bind(this));
        this.registerEventListener(MapLocationAvailabilityEvent.LOCATION_UNAVAILABLE, this._handleLocationUnavailable.bind(this));
    }

    destroy() {
        super.destroy();

        this._target.bg.removeEventListener('click', this._onMapClickBound);

        for (let i = 0; i < this._mapLocationMediators.length; i++) {
            const mapLocationMediator = this._mapLocationMediators[i];
            mapLocationMediator.destroy();
        }

        this._mapLocationMediators = null;
    }

    _initializeNodes() {
        const locations = this._mapModel.locations;
        for (let i = 0; i < locations.length; i++) {
            const location = locations[i];
            const locationSkin = this._target[location.instanceName];
            if (!locationSkin) {
                console.warn(`[MapMediator] Skin for the following location was not found: `, location);
            }
            locationSkin.customData = {
                location,
            };

            /** @type {MapLocationMediator} */
            const locationMediator = this._mediatorManager.createMediator(locationSkin, SkinKeyRegistry.MAP_LOCATION);
            locationMediator.disable();

            this._mapLocationMediators.push(locationMediator);

            this._target.bg[location.id].text = this._languagePack.getText(`map.locations.${location.id}.name`);
        }
    }

    _handleLocationAvailable(evt) {
        /** @type {MapLocationAvailabilityEvent} */
        const mapLocationAvailabilityEvent = evt.params.data;
        const locationMediator = this._mapLocationMediators.find(n => n.location === mapLocationAvailabilityEvent.mapLocation);
        locationMediator.enable();
    }

    _handleLocationUnavailable(evt) {
        /** @type {MapLocationAvailabilityEvent} */
        const mapLocationAvailabilityEvent = evt.params.data;
        const locationMediator = this._mapLocationMediators.find(n => n.location === mapLocationAvailabilityEvent.mapLocation);
        locationMediator.disable();
    }

    _onMapClick() {
        this.dispatch(MapInteractionEvent.CLICK);
        this.dispatch(CloseMapCharacterMenuEvent.CLOSE_ALL);
    }
}